/**
 * ES6 Javascript, to be compiled by Babel into JS (if you like)
 * Mostly created so things will uglify nicely during grunt deployment (grunt-uglify does not like es6)
 * Created by joshua on 7/12/17.
 */
function VideoInserter(callingPage) {
    'use strict';

    //for all these variables, the "first" value (after the question mark) is for "index.php' and the second value is "xmLaserScanning"
    const initialDelay = callingPage === 'front' ? 700 : 2000;
    const loopDelay = callingPage === 'front' ? 0 : 2000;
    const poster = callingPage === 'front' ? '' : '/img/transparent.png';

    if (window.matchMedia('(min-width: 800px)').matches) {
        let src, videoSource;
        let video = $('<video>', {
            playsinline: true,
            muted: true,
            loop: false,
            poster: poster,
            id: 'bgvid',
            class: 'noFlip'
        });
        if (callingPage === 'front') {
            videoSource = '/video/cityRenderBG.mp4';
        }
        if (callingPage === 'laserScanning') {
            videoSource = '/video/scanBannerV7.mp4';
        }

        src = $('<source>', { src: videoSource, type: 'video/mp4' });

        //set up a loop that alternately adds/removes classes
        video.on('ended', () => {
            let classToRemove = video.hasClass('flip') ? 'flip' : 'noFlip';
            let classToAdd = classToRemove === 'flip' ? 'noFlip' : 'flip';
            video.addClass(classToAdd);
            video.removeClass(classToRemove);
            window.setTimeout(() => {
                video[0].play();
            }, loopDelay);
        });

        video.append(src);
        $('#vidHolder').append(video);
        window.setTimeout(() => {
            video[0].play();
        }, initialDelay);
    }
}
